import { ComponentChildren } from 'preact';

export const Tag = ({ children }: { children: ComponentChildren }) => (
  <span className="vgp-tag">{children}</span>
);
